import { useState } from 'react';
import { API_URL, authFetch, parseJsonResponse, responseErrorMessage } from '../../utils/auth';
import ToolSidebar from '../../utils/ToolSideBar';
import '../../../css/client/ClientFilesPage.css';

export default function ClientFilesPage({ files = [], projects = [], loading, error, onUploaded }) {
  const [projectId, setProjectId] = useState('');
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');
  const groupedFiles = files.reduce((groups, item) => {
    const category = item.category || 'project_files';
    groups[category] = groups[category] || [];
    groups[category].push(item);
    return groups;
  }, {});

  async function uploadFile(event) {
    event.preventDefault();
    if (!projects.length) {
      setStatus('No accepted client project is available for uploads yet.');
      return;
    }
    if (!file || !projectId) {
      setStatus('Choose a project and file first.');
      return;
    }
    const body = new FormData();
    body.append('project_id', projectId);
    body.append('file', file);
    const response = await authFetch(API_URL + '/client/files/', { method: 'POST', body });
    const data = await parseJsonResponse(response);
    if (!response.ok) {
      setStatus(responseErrorMessage(response, data, 'Unable to upload file.'));
      return;
    }
    setStatus('File uploaded.');
    setFile(null);
    setProjectId('');
    onUploaded?.();
  }

  return (
    <div className='client-files-shell'>
      <ToolSidebar active='files' />
      <main className='client-files-page'>
        <h1>Project Files</h1>
        <form className='file-upload-card' onSubmit={uploadFile}>
          <h2>Upload a File</h2>
          <select value={projectId} onChange={(e) => setProjectId(e.target.value)}>
            <option value=''>Select project</option>
            {projects.map((project) => <option key={project.id} value={project.id}>{project.project_name || project.business_name || 'Project ' + project.id}</option>)}
          </select>
          <input type='file' onChange={(e) => setFile(e.target.files?.[0] || null)} />
          <button type='submit' disabled={!projects.length}>Upload File</button>
          {status && <small>{status}</small>}
        </form>
        {loading ? <div className='empty-state'><p>Loading files...</p></div> : error ? <div className='empty-state'><p>{error}</p></div> : files.length === 0 ? (
          <div className='empty-state'><h3>No files uploaded yet</h3><p>Files shared during your project will appear here.</p></div>
        ) : Object.entries(groupedFiles).map(([category, categoryFiles]) => (
          <section key={category} className='file-category-section'>
            <h2 className='category-title'>{category.replaceAll('_', ' ')}</h2>
            <div className='file-grid'>
              {categoryFiles.map((item) => (
                <div className='file-card' key={item.id}>
                  <h3>{item.title}</h3>
                  <p className='file-name'>{item.original_filename}</p>
                  <div className='file-meta'><small>Uploaded by: {item.uploaded_by}</small><small>{new Date(item.uploaded_at).toLocaleDateString()}</small></div>
                  <a href={item.download_url || item.url} target='_blank' rel='noreferrer' className='download-btn'>View / Download</a>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
